var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import texts from './texts';
export var Spinner = function (_a) {
    var className = _a.className, _b = _a.immediate, immediate = _b === void 0 ? false : _b, _c = _a.large, large = _c === void 0 ? false : _c, loadingText = _a.loadingText, _d = _a.locale, locale = _d === void 0 ? 'nb' : _d, rest = __rest(_a, ["className", "immediate", "large", "loadingText", "locale"]);
    return (React.createElement("div", __assign({ "aria-live": "assertive", className: classNames('ffe-loading-spinner-container', className) }, rest, { "data-testid": "spinner-container" }),
        React.createElement("span", { className: classNames('ffe-loading-spinner', { 'ffe-loading-spinner--immediate': immediate }, { 'ffe-loading-spinner--large': large }), role: "img", "aria-label": texts[locale].ariaLabel, "aria-hidden": !!loadingText }),
        loadingText));
};
